import { createFileRoute } from '@tanstack/react-router';
import Refuelings from '../../components/Refuelings';
import { PERMISSION_REFUELING } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/refuelings/$vehicleId')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_REFUELING, ['read'], '/unauthorized', context);
    return {
      ...context,
      isMenuDisabled: true,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteView,
});

function RouteView() {
  return <Refuelings />;
}
